import {
  DELETEWALLETOWNER_SUCCESS,
  DELETEWALLETOWNER_FAILED,
  RESET_DELETEWALLETOWNER,
  LOADING_DELETEWALLETOWNER,
  NETWORK_ERROR_DELETEWALLETOWNER,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetDeleteWalletOwner = () => {
  return { type: RESET_DELETEWALLETOWNER };
};

const deleteWalletOwner = (userData, authTokenIs) => async (dispatch) => {
  console.log({ userData });

  dispatch({ type: LOADING_DELETEWALLETOWNER });
  await adminServices
    .post("deleteWalletOwner", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(deleteWalletOwnersuccess(res.data));
          break;
        default:
          dispatch(deleteWalletOwnerFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_DELETEWALLETOWNER,
        payload: err,
      });
    });
};
function deleteWalletOwnersuccess(data) {
  return {
    type: DELETEWALLETOWNER_SUCCESS,
    payload: data,
  };
}
function deleteWalletOwnerFailed(data) {
  return {
    type: DELETEWALLETOWNER_FAILED,
    payload: data,
  };
}

export { resetDeleteWalletOwner, deleteWalletOwner };
